<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">题库搜索</span>
            </template>
            <template #left>
                <router-link to="/">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/"><van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/></router-link>
            </template>
        </van-nav-bar>

        <van-tabs v-model="tabActive" @click="onLoad(true)">
            <van-tab title="所有" name="0">
            </van-tab>
            <van-tab title="单选题" name="1">
            </van-tab>
            <van-tab title="判断题" name="2">
            </van-tab>
            <van-tab title="多选题" name="3">
            </van-tab>
        </van-tabs>
        <van-search show-action v-model="searchValue" @search="onLoad(true)" placeholder="请输入要搜索的内容" >

            <template #action>
                <div @click="onLoad(true)">搜索</div>
            </template>
        </van-search>



        <van-divider :style="{margin: '6px 0' }">为你搜索到{{listTotal}}道题</van-divider>

        <van-list
                v-model="loading"
                :finished="finished"
                :error.sync="error"
                :error-text="error_text"
                finished-text="没有更多了"
                @load="onLoad(false)"
        >
            <van-collapse v-model="listActive">

                <van-collapse-item v-for="topic in topics" :key="topic.id" :title="topic.content" :name="topic.id">

                    <template #title>
                        <div>
                            <van-tag size="medium" type="danger">{{getTopicTypeName(topic.type)}}</van-tag>
                            {{topic.content}} </div>
                    </template>

                    <van-checkbox v-for="option in topic.options"
                                  icon-size="15"
                                  style="padding-bottom: 10px"
                                  v-model="option.is_answer"
                                  :key="option.id"
                                  label-disabled>
                        {{2 === topic.type ? '':getAbcText(option)}}
                        {{option.content}}
                    </van-checkbox>


                    <br>
                    <van-row gutter="20">
                        <van-col>
                            <van-button size="mini" type="info" plain >标准答案</van-button>
                        </van-col>
                        <van-col span="6">
                            <div style="border-bottom:1px solid #000;text-align: center">
                                {{topic.answer}}
                            </div>
                        </van-col>
                    </van-row>


                </van-collapse-item>

            </van-collapse>
        </van-list>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                tabActive:0,
                page:1,
                listTotal:0,
                listActive:[],

                loading:false,
                finished:true,
                error:false,
                error_text: "",
                searchValue: "",

                topics:[]
            };
        },
        created() {

        },
        methods:{
            onLoad(isNew){
                if (isNew){
                    this.topics=[];
                    this.page=1;
                    this.finished=false;
                }
                this.loading = true;
                this.$http.get("/wechat/topics", {
                    params: {
                        pre_page:15,
                        page:this.page,
                        special: this.tabActive,
                        word:this.searchValue
                    }
                }).then(res => {
                    this.loading = false;
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.error = true
                        this.error_text = res.data.msg
                        return
                    }
                    if (!res.data.data || res.data.data.length <= 0) {
                        this.finished = true
                        return;
                    }
                    this.page++

                    this.listTotal = res.data.meta.total
                    this.topics = this.topics.concat(res.data.data);
                });
            },


            getTopicTypeName(type) {
                switch (type) {
                    case 1:
                        return '单选题';
                    case 2:
                        return '判断题';
                    case 3:
                        return '多选题';
                    default:
                        return '未知';
                }
            },
            getAbcText(option) {
                switch (option.sort) {
                    case 0:
                        return "A、"
                    case 1:
                        return "B、"
                    case 2:
                        return "C、"
                    case 3:
                        return "D、"
                    case 4:
                        return "E、"
                    case 5:
                        return "F、"
                    case 6:
                        return "G、"
                    case 7:
                        return "H、"
                    default:
                        return ""
                }
            },
        }
    }
</script>
